import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Flag, Rocket, Ticket, Zap } from "lucide-react";
import { api } from "@/lib/api";
import { useNow, countdown } from "@/hooks/useNow";
import { OddsButton } from "@/components/OddsButton";
import { kickoff } from "@/lib/api";

export const BoostedOdds = ({ events }) => {
  const boosted = (events || []).filter((e) => e.boosted);
  if (!boosted.length) return null;
  return (
    <section className="space-y-2">
      <h2 className="flex items-center gap-2 font-display text-lg font-black uppercase tracking-tight">
        <Zap className="h-5 w-5 text-[#F59E0B]" /> Today's boosted odds
      </h2>
      <div className="scroll-thin flex gap-3 overflow-x-auto pb-1">
        {boosted.map((e) => (
          <div key={e.id} data-testid={`boosted-card-${e.id}`} className="w-72 shrink-0 rounded-lg border border-[#F59E0B]/40 bg-gradient-to-br from-[#F59E0B]/10 to-[#121824] p-3">
            <div className="text-[11px] uppercase tracking-wider text-slate-400">{e.league} · {kickoff(e.start)}</div>
            <div className="mt-1 truncate text-sm font-semibold">{e.home} v {e.away}</div>
            <div className="mt-2 flex items-center justify-between gap-2">
              <span className="text-xs text-slate-400">
                {e.boosted.pick === "home" ? e.home : e.away} to win · was <s className="font-odds">{e.boosted.was.toFixed(2)}</s>
              </span>
              <div className="w-24"><OddsButton ev={e} pick={e.boosted.pick} label="Boost" /></div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

const Tile = ({ to, icon: I, title, sub, accent, testid }) => (
  <Link to={to} data-testid={testid} className="group flex items-center gap-3 rounded-lg border border-[#1E293B] bg-[#121824] p-4 transition-[border-color,transform] hover:-translate-y-0.5 hover:border-[#10B981]/60">
    <span className="flex h-11 w-11 items-center justify-center rounded-lg" style={{ background: `${accent}22`, color: accent }}>
      <I className="h-5 w-5" />
    </span>
    <div className="min-w-0">
      <div className="font-display text-base font-black uppercase">{title}</div>
      <div className="truncate font-odds text-xs text-slate-400">{sub}</div>
    </div>
  </Link>
);

export const GamesStrip = () => {
  const now = useNow(1000);
  const { data: racing } = useQuery({ queryKey: ["racing"], queryFn: () => api.get("/racing").then((r) => r.data), refetchInterval: 15000 });
  const { data: lotto } = useQuery({ queryKey: ["lotto"], queryFn: () => api.get("/lotto").then((r) => r.data), refetchInterval: 60000 });
  const race = racing?.upcoming?.find((r) => new Date(r.start).getTime() > now);
  const draw = lotto?.[0];
  return (
    <div className="grid gap-3 sm:grid-cols-3">
      <Tile to="/racing" icon={Flag} accent="#10B981" testid="home-tile-racing" title="Horse Racing"
        sub={race ? `${race.track_name} R${race.race_no} in ${countdown(race.start, now)}` : "Races every minute"} />
      <Tile to="/lotto" icon={Ticket} accent="#F59E0B" testid="home-tile-lotto" title="Lucky Numbers"
        sub={draw?.next_draws?.[0] ? `${draw.name} in ${countdown(draw.next_draws[0].at, now)}` : "12 world lottos"} />
      <Tile to="/fly-high" icon={Rocket} accent="#EF4444" testid="home-tile-crash" title="Fly High" sub="Cash out before it flies away" />
    </div>
  );
};
